export interface AtlasLogoProps {
  size?: number;
}

// Brighter coral than the app's --apm-accent so the waypoints/star pop against
// the dark logo tile instead of blending in. Fixed hue (not a theme token) —
// reads clearly on both the dark (light-mode) and light (dark-mode) tile.
const LOGO_ACCENT = '#FF7A54';

/**
 * Atlas brand mark — the "A" summit with an ascending dashed trajectory,
 * waypoint dots and a guiding star. Sourced from mockups/atlas-mark-*.svg.
 *
 * Rendered background-free so it can sit inside the app's existing logo box
 * (which supplies the rounded-rect fill via `var(--apm-ink)`). Strokes use
 * `currentColor` — the parent box sets `color: var(--apm-bg-2)` — so the mark
 * inverts correctly in both themes; the accents use a fixed bright coral.
 */
export function AtlasLogo({ size = 32 }: AtlasLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 160 160"
      fill="none"
      role="img"
      aria-label="Atlas"
      style={{ display: 'block', flexShrink: 0 }}
    >
      {/* Ascending dashed trajectory */}
      <path
        d="M53.5 100 C70 78 88 92 114 67"
        stroke="currentColor"
        strokeWidth={9}
        strokeDasharray="5 12"
        strokeLinecap="round"
        fill="none"
        opacity={0.9}
      />
      {/* The A summit */}
      <path
        d="M42 126 L80 40 L118 126"
        stroke="currentColor"
        strokeWidth={13}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Waypoint dots + guiding star, brand accent */}
      <circle cx="53.5" cy="100" r="7" fill={LOGO_ACCENT} />
      <circle cx="97" cy="79" r="7" fill={LOGO_ACCENT} />
      <path
        d="M126 49 L130 57 L138 60 L130 63 L126 71 L122 63 L114 60 L122 57 Z"
        fill={LOGO_ACCENT}
      />
      <circle cx="80" cy="20" r="9" fill={LOGO_ACCENT} />
    </svg>
  );
}
